import { render, staticRenderFns } from "./GiftCardUsageRules.vue?vue&type=template&id=e104e216&"
import script from "./GiftCardUsageRules.vue?vue&type=script&lang=ts&"
export * from "./GiftCardUsageRules.vue?vue&type=script&lang=ts&"
import style0 from "./GiftCardUsageRules.vue?vue&type=style&index=0&id=e104e216&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports